import React from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { Button, Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { LinkComponent } from '../components/Global/LinkComponents';

const useStyles = () => makeStyles((theme) => ({
  errorContainer: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.white.main,
    maxWidth: '75%',
    position: 'relative',
    margin: '0 auto',
  },
  innerContent: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  logo: {
    display: 'block',
    margin: '0 auto',
  },
}));

function Error({ statusCode, auth }) {
  const classes = useStyles()();
  const router = useRouter();
  const errorMessage = (_statusCode) => {
    switch (_statusCode) {
      case 404:
        return (
          <>
            <Typography component='h1' variant='h3' color='primary' gutterBottom>
              {'SORRY'}
            </Typography>
            <Typography component='h1' variant='h4' color='primary' gutterBottom>
              {'The Page you are looking for Could not be found.'}
            </Typography>
          </>
        );
      case 403:
        return (
          <>
            <Typography component='h1' variant='h3' color='primary' gutterBottom>
              {'SORRY'}
            </Typography>
            <Typography component='h1' variant='h4' color='primary' gutterBottom>
              {'You do not have access to this page.'}
            </Typography>
          </>
        );
      default:
        return (
          <>
            <Typography component='h1' variant='h3' color='primary' gutterBottom>
              {'SORRY'}
            </Typography>
            <Typography component='h1' variant='h6' color='primary' gutterBottom>
              {'There was an unknown error. Try refreshing and if the problem coninues contact'}
              {' '}
              <a href='mailto:research@ssshsg.org?subject=SSSF Page load error' className='contactLink'>
                {'Maty Petcharaporn'}
              </a>
              {'.'}
            </Typography>
          </>
        );
    }
  };
  return (
    <div className='errorPage'>
      <Head>
        <title>{'SSSF Error'}</title>
        <link rel='icon' href='/favicon.ico' />
      </Head>

      <main>
        <Grid container className={classes.errorContainer} spacing={3}>
          <Grid item xs={12}>
            <img src='/SSSF_color_logo.png' className={classes.logo} alt='SSSF color logo' />
          </Grid>
          <Grid item xs={12} className={classes.innerContent}>
            {statusCode ? (
              errorMessage(statusCode)
            ) : (
              <>
                <Typography component='h1' variant='h3' color='primary' gutterBottom>
                  {'SORRY'}
                </Typography>
                <Typography component='h1' variant='h6' color='primary' gutterBottom>
                  {'There was a browser error. Try refreshing and if the problem coninues contact'}
                  {' '}
                  <a href='mailto:research@ssshsg.org?subject=SSSF Page load error' className='contactLink'>
                    {'Maty Petcharaporn'}
                  </a>
                  {'.'}
                </Typography>
              </>
            )}
            {auth.user ? (
              <Button variant='contained' color='primary' onClick={() => router.back()} className={classes.backHome}>
                {'BACK'}
              </Button>
            ) : (
              <Button
                component={LinkComponent}
                variant='contained'
                color='primary'
                href='/login'
                className={classes.backHome}
              >
                {'LOGIN'}
              </Button>
            )}
          </Grid>
        </Grid>
      </main>
    </div>
  );
}

export const getServerSideProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { props: { statusCode } };
};

export default connect((state) => state)(Error);
